import React, { useEffect, useState } from 'react';
import { IconButton, Paper, Typography } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import styles from '../OptionsBoardStyles';
import { useDispatch, useSelector } from 'react-redux';
import { setOptionChainAction } from '../../../actions/optionChainAction';

const Warnings = () => {
  const [warningsState, setWarningsState] = useState([]);
  const { optionChainReducer } = useSelector((state) => state);
  const dispatch = useDispatch();
  const { warnings } = optionChainReducer;

  useEffect(() => {
    setWarningsState(warnings);
    return () => {
      setWarningsState([]);
    };
  }, [warnings]);

  const setOptionChainState = (payload) =>
    dispatch(setOptionChainAction(payload));

  const removeWarning = async (index) => {
    const removedWarnings = warningsState.filter(
      (warning, i) => warning.index !== index
    );
    setOptionChainState({
      warnings: removedWarnings,
    });

    setWarningsState(removedWarnings);
  };

  return warningsState.map(({ warningText, index }) => (
    <Paper elevation={5} key={warningText} style={{ ...styles.warningPaper }}>
      <IconButton
        aria-label="Close"
        size="small"
        style={styles.closeButton}
        onClick={() => removeWarning(index)}
      >
        <Close />
      </IconButton>
      <div styles={styles.warningRightSide}>
        <Typography variant="body1" component="p" style={styles.warningText}>
          {warningText}{' '}
        </Typography>
      </div>
    </Paper>
  ));
};

export default Warnings;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/Warnings/index.jsx